import * as React from "react";
import { cls } from "@utdanningsdirektoratet/utils/cls";
import styles from "./Placeholder.module.less";

type PlaceholderProps = {
  className?: string;
  width?: string | number;
  height?: string | number;
  inverted?: boolean;
};

const Placeholder: React.FC<PlaceholderProps> = ({ className, width = 100, height = 1, inverted }) => {
  const placeholderClass = cls(
    {
      [styles.placeholder]: true,
      [styles.placeholderInverted]: inverted,
    },
    className
  );
  const innerStyle = {
    width: `${width}%`,
  };
  const outerStyle = {
    height: `${height}rem`,
  };
  return (
    <div style={outerStyle} className={placeholderClass}>
      <div style={innerStyle} className={styles.placeholderBox} />
    </div>
  );
};

export default Placeholder;
